import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-badges-page-ui',
    templateUrl: './bb-badges-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbBadgesPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
